let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("coqKm")).then(() => parcelRequire('64g7t'));